/* eslint no-template-curly-in-string: "off" */
import { PAYMENT_STATUSES } from "../../../utils/enums";

export const defaultFaqs = {
  global: {
    default: [
      // {
      //   question: 'global #1 question',
      //   answer: 'global #1 answer',
      // },
      // {
      //   question: 'global #2 question',
      //   answer: 'global #2 answer',
      // },
    ],
    byPaymentStatus: {
      [PAYMENT_STATUSES.PENDING_ACCEPTANCE]: [
        // {
        //   question: 'global pending acceptance question #1',
        //   answer: 'global pending acceptance answer #1'
        // },
        {
          question: '¿Cuánto tiempo tardaré en recibir mi pago?',
          answer: 'En términos generales, los fondos son entregados electrónicamente a la red de pagos que seleccione en tan solo unos momentos, normalmente, en uno o dos minutos. Usted recibirá un mensaje de confirmación una vez que su pago esté programado para ser depositado; Amazon y PayPal también enviarán una confirmación final una vez que los fondos hayan sido recibidos en su cuenta. Para las transferencias bancarias directas, por favor, consulte su estado de cuenta bancario en línea para verificar la recepción.'
        },
        {
          question: '¿Puedo recibir un cheque impreso?',
          answer: 'No. Se le pagará al instante a través de un pago electrónico conveniente. Mediante el uso de pagos electrónicos, Chameleon Insurance elimina la molestia y el costo de la gestión, la impresión y el envío de cheques físicos.'
        }
      ],
      [PAYMENT_STATUSES.COMPLETE]: [
        // {
        //   question: 'global complete question #1',
        //   answer: 'global complete answer #1'
        // },
      ]
    }
  }
};

export default defaultFaqs;
